<template>
    <b-container flex>
        <div style="padding-top: 20px; padding-bottom: 10px"><span
                style="font-weight: bold; font-size: large; padding-top: 20px; padding-bottom: 10px">Metrics</span>
        </div>
        <b-row style="margin-bottom: 10px ">
            <b-col sm="6">Grid electricity kWh/case</b-col>
            <b-col sm="4">
                <b-form-input v-model="totalGridElectricityPerCaseCalculated" readonly min="0" max="1000" step=".10"
                              type="number"></b-form-input>
            </b-col>
            <b-col sm="2"></b-col>
        </b-row>

        <b-row style="margin-bottom: 10px ">
            <b-col sm="6">Solar electricity kWh/case</b-col>
            <b-col sm="4">
                <b-form-input readonly v-model="totalGridSolarPerCaseCalculated" min="0" max="1000" step=".10"
                              type="number"></b-form-input>
            </b-col>
            <b-col sm="2"></b-col>
        </b-row>
        <b-row style="padding-top:5px;">

            <b-col sm="6">Total electricity kWh/case</b-col>
            <b-col sm="4">
                <b-form-input readonly v-model="totalElectricityPerCaseCalculated" min="0" max="1000" step=".10"
                              type="number"></b-form-input>
            </b-col>
            <b-col sm="2"></b-col>
        </b-row>
        <b-row style="padding-top:10px;">

            <b-col sm="6">Gals Water/Gal Wine (Process + Hospitality + Offices)</b-col>
            <b-col sm="4">
                <b-form-input readonly v-model="insideWaterPerGalOfWine" min="0" max="1000" step=".10"
                              type="number"></b-form-input>
            </b-col>
            <b-col sm="2"></b-col>
        </b-row>
        <b-row style="padding-top:5px;">
            <b-col sm="6">Gals Landscape Water/Gal Wine</b-col>
            <b-col sm="4">
                <b-form-input readonly v-model="landscapeWaterPerGalOfWine" min="0" max="1000" step=".10"
                              type="number"></b-form-input>
            </b-col>
            <b-col sm="2"></b-col>
        </b-row>
        <b-row style="padding-top:5px;">

            <b-col sm="6">Total Water/Gal Wine</b-col>
            <b-col sm="4">
                <b-form-input readonly v-model="totalWaterPerGalOfWine" min="0" max="1000" step=".10"
                              type="number"></b-form-input>
            </b-col>
            <b-col sm="2"></b-col>
        </b-row>
    </b-container>
</template>

<script>
import Bus from "../eventBus";

export default {
  name: "PerCaseMetrics",
  props: {year: Number},
  data() {
    return {
      totalGridElectricityVal: 0,
      totalGridSolarVal: 0,
      myYear: this.year,
      equivalentCases: 0,
      totalGallonsOfWine: 0,
      wineryProcess: 0,
                officeWater: 0, // change this once the land water is done
                landWater: 0,
                landscapeWaterPerGalOfWine: 0,
                //totalWaterPerGalOfWine: 0,
                totalGridElectricityPerGalOfWine: 0,
                totalGridElectricityPerCase: 0,
                totalElectricityPerCase: 0,
                totalGridSolarPerCase: 0,
                insideWaterPerGalOfWine: 0


            }
        },
        created() {
            Bus.$on('grid-edited', this.calcVariFromUpdate);
            Bus.$on('wine-production', this.wineProductionUpdate);

        },
        beforeDestroy() {
            Bus.$off('grid-edited', this.calcVariFromUpdate);
            Bus.$off('wine-production', this.wineProductionUpdate);
        },
        computed:
            {
                totalWaterPerGalOfWine: function () {
                    let totalGalPerWine = this.totalGallonsOfWine !== 0 ? (this.landWater + this.wineryProcess + this.officeWater) / this.totalGallonsOfWine : 0;
                    return totalGalPerWine.toFixed(1);
                },
                totalGridElectricityPerCaseCalculated: function () {
                    //let number = this.equivalentCases !== 0 ? (this.totalGridElectricityVal) / this.equivalentCases : 0;
                    let calculatedGridElectricity = this.equivalentCases !== 0 ? Number((this.totalGridElectricityVal) / this.equivalentCases) : 0;
                    return calculatedGridElectricity.toFixed(1);

                },
                totalGridSolarPerCaseCalculated: function () {
                    let number = this.equivalentCases !== 0 ? Number((this.totalGridSolarVal) / this.equivalentCases) : 0;
                    return number.toFixed(1);
                },
                totalElectricityPerCaseCalculated: function () {
                    return (this.equivalentCases !== 0 ? (this.totalGridElectricityVal + this.totalGridSolarVal) / this.equivalentCases : 0).toFixed(1);
                }/*,
                totalWater: function () {
                    console.log("land Water: " + this.landWater);
                    console.log("Office Water: " + this.officeWater);
                    console.log("Total Gallons Of Wine: " + this.totalGallonsOfWine);
                    console.log("Equivalent Cases: " + this.equivalentCases);
                    return this.totalGallonsOfWine !== 0 ? (this.landWater + this.officeWater) / this.totalGallonsOfWine : 0;
                }*/
            },
        methods: {
            calcVariFromUpdate: function (total) {
              if (Number(total.year) === this.myYear) {
                if (total.gridType === "solarProductivity") {
                  this.totalGridSolarVal = total.total;
                  this.totalElectricityPerCase = this.equivalentCases !== 0 ? ((this.totalGridElectricityVal + this.totalGridSolarVal) / this.equivalentCases).toFixed(1) : 0;
                  this.totalGridSolarPerCase = this.equivalentCases !== 0 ? (this.totalGridSolarVal / this.equivalentCases).toFixed(1) : 0;
                } else if (total.gridType === "electricMeter" || total.gridType === "electricMeter2" ||
                    total.gridType === "electricMeter3") {
                  this.totalGridElectricityVal = total.total;
                  this.totalGridElectricityPerCase = this.equivalentCases !== 0 ? ((this.totalGridElectricityVal) / this.equivalentCases).toFixed(1) : 0;
                  this.totalElectricityPerCase = this.equivalentCases !== 0 ? ((this.totalGridElectricityVal + this.totalGridSolarVal) / this.equivalentCases).toFixed(1) : 0;
                } else if (total.gridType === "waterGrid") {
                        this.officeWater = total.tastingOffices;
                        this.landWater = total.landscaping;
                        this.wineryProcess = total.wineryProcess;
                        this.totalGallonsOfWine = (this.landWater + this.wineryProcess + this.officeWater);
                        //this.totalWaterPerGalOfWine = this.totalGallonsOfWine !== 0 ? (this.landWater + this.wineryProcess + this.officeWater) / this.totalGallonsOfWine : 0;
                        this.landscapeWaterPerGalOfWine = this.totalGallonsOfWine !== 0 ? (this.landWater / this.totalGallonsOfWine).toFixed(1) : 0;
                    } else if (total.gridType === "powerEmission") {
                        this.totalGridElectricityVal = total.totalGrid;
                        this.totalGridSolarVal = total.totalSolar;
                        this.totalGridElectricityPerCase = this.equivalentCases !== 0 ? ((this.totalGridElectricityVal) / this.equivalentCases).toFixed(1) : 0;
                        this.totalElectricityPerCase = this.equivalentCases !== 0 ? ((this.totalGridElectricityVal + this.totalGridSolarVal) / this.equivalentCases).toFixed(1) : 0;
                        this.totalGridSolarPerCase = this.equivalentCases !== 0 ? (this.totalGridSolarVal / this.equivalentCases).toFixed(1) : 0;
                    }
                }
            },
            wineProductionUpdate: function (wineProduction) {
              if (Number(wineProduction.year) === this.myYear) {
                if (wineProduction.type === "totalWine") {
                  this.totalGallonsOfWine = wineProduction.total;
                  //this.totalWaterPerGalOfWine = this.totalGallonsOfWine !== 0 ? ((this.landWater + this.wineryProcess + this.officeWater) / this.totalGallonsOfWine).toFixed(1) : 0;
                  this.landscapeWaterPerGalOfWine = this.totalGallonsOfWine !== 0 ? (this.landWater / this.totalGallonsOfWine).toFixed(1) : 0;
                  this.insideWaterPerGalOfWine = this.totalGallonsOfWine !== 0 ? ((this.wineryProcess + this.officeWater) / this.totalGallonsOfWine).toFixed(1) : 0;
                } else {
                  this.equivalentCases = wineProduction.total;
                }
              }

            }
        }
    }
</script>

<style scoped>

</style>
